import { injectLocal } from '@vueuse/core';
import { PDP_PRODUCT_QUICKVIEW_REPO } from './const';

/**
 * Injects and returns the product quick view (PQV) state and functions provided by `useProductQuickviewProvide`.
 * This composable must be used within a component that is a descendant of a component
 * where `useProductQuickviewProvide` has been called.
 *
 * It provides access to reactive state like `isPqvPayloadActive` and methods like `watchPayloadUpdate`.
 *
 * @throws {Error} If `useProductQuickviewProvide` has not been called in an ancestor component.
 * @returns The provided PQV data, including reactive state and utility functions.
 */
export function useProductQuickview() {
  // Injects the data provided under the PDP_PRODUCT_QUICKVIEW_REPO key from an ancestor component.
  const productQuickviewData = injectLocal(PDP_PRODUCT_QUICKVIEW_REPO);

  // Throws a descriptive error if the provide composable was not used in an ancestor.
  // This is a safeguard to ensure the component has access to the necessary context.
  if (!productQuickviewData) {
    throw new Error('useProductQuickview() requires the provide composable, useProductQuickviewProvide(), to be called');
  }

  // Returns the injected data for use in the component.
  return productQuickviewData;
}
